import * as React from 'react';
export const KRSvg = React.forwardRef(function KRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M1.994 2h12.012C15.106 2 16 2.9 16 4.009v7.982A2.003 2.003 0 0 1 14.006 14H1.994C.894 14 0 13.1 0 11.991V4.01C0 2.902.893 2 1.994 2Zm.013 1C1.45 3 1 3.456 1 3.995v8.01A1 1 0 0 0 2.007 13h11.986c.556 0 1.007-.456 1.007-.995v-8.01A1 1 0 0 0 13.993 3H2.007Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M11 4.207V4h1.207L13.5 5.793V6h-1.207L11 4.207ZM2.5 5.793 3.793 4H5v.207L3.707 6H2.5v-.207Zm8.5 6L12.293 10H13.5v.207L12.207 12H11v-.207Zm-8.5-1.586V10h1.207L5 11.793V12H3.793L2.5 10.207Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M5 8a3 3 0 1 1 5.711 1.286H5.29A2.988 2.988 0 0 1 5 8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M9.436 7.346c.987 0 1.395.677 1.52 1.173a3.001 3.001 0 0 1-2.896 2.48c-1.18-.021-2.2-.663-2.711-1.594A2.986 2.986 0 0 1 5 8.025a2.81 2.81 0 0 1 .336-1.31c.002.04.003.084.003.131 0 .578-.002 1.787 1.45 1.787 1.454 0 1.411-1.287 2.647-1.287Z',
      }),
    ),
  );
});
KRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KR = {
  category: 'flag',
  colorable: false,
  name: 'KR',
  svg: KRSvg,
};
